import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.f4q_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.c4q_1;
    if (index >= interceptors.q2()) {
      $this.g4q();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.f4q_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.e4q_1, $completion);
  }
   while (true);
  return $this.e4q_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.c4q_1 = interceptors;
        this.d4q_1 = coroutineContext;
        this.e4q_1 = subject;
        this.f4q_1 = 0;
      }
      xv() {
        return this.d4q_1;
      }
      h4q() {
        return this.e4q_1;
      }
      g4q() {
        this.f4q_1 = -1;
      }
      *i4q(subject, $completion) {
        this.e4q_1 = subject;
        return yield* this.j4q($completion);
      }
      *j4q($completion) {
        var index = this.f4q_1;
        if (index < 0)
          return this.e4q_1;
        if (index >= this.c4q_1.q2()) {
          this.g4q();
          return this.e4q_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *k4q(initial, $completion) {
        this.f4q_1 = 0;
        this.e4q_1 = initial;
        return yield* this.j4q($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
